import { render, staticRenderFns } from "./CodeMatch.vue?vue&type=template&id=0c002fd4&scoped=true"
import script from "./CodeMatch.vue?vue&type=script&lang=js"
export * from "./CodeMatch.vue?vue&type=script&lang=js"
import style0 from "./CodeMatch.vue?vue&type=style&index=0&id=0c002fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c002fd4",
  null
  
)

export default component.exports